import { Box, Button, Stack } from '@mui/material';
// material
// utils
import { UploadMultiFileProps } from 'components';
import UploadDropZone from './UploadDropZone';
import UploadFileList from './UploadFileList';
import { showMessage } from 'utils/snackbar';

export default function UploadMultiFile({
  type,
  showPreview = false,
  files,
  onRemove,
  onDefault,
  onRemoveAll,
  ownerId,
  boostGroupId,
  fileToUpload,
  onSave: save = () => null,
  openSnackBar,
  sx,
  boostGroupImages,
  isSiteConf,
  ...other
}: UploadMultiFileProps) {
  const hasFile = fileToUpload.length > 0;

  const getUploadFileList = (fileArray: any[], showDefaultButton: boolean) => {
    return (
      <UploadFileList
        type={type}
        hasFile={hasFile}
        ownerId={ownerId}
        boostGroupId={boostGroupId}
        fileArray={fileArray}
        boostGroupImages={boostGroupImages}
        showPreview={showPreview}
        showDefaultButton={showDefaultButton}
        onDefault={onDefault}
        onRemove={onRemove}
        openSnackBar={openSnackBar}
        isSiteConf={isSiteConf}
      />
    );
  };

  const checkUploadLength = () => {
    if (fileToUpload.length > 5) {
      showMessage('You can only upload up to 5 images at a time.', 'error');
      fileToUpload.splice(5);
      return fileToUpload;
    }
    return fileToUpload;
  };

  return (
    <Box sx={{ width: '100%', ...sx }}>
      {getUploadFileList(files, true)}
      <UploadDropZone {...other} />
      {getUploadFileList(checkUploadLength(), false)}

      {hasFile && (
        <Stack direction="row" justifyContent="flex-end">
          <Button onClick={onRemoveAll} sx={{ mr: 1.5 }}>
            Remove all
          </Button>
          <Button variant="contained" onClick={save} data-testid={'imageUpload-' + type}>
            Upload files
          </Button>
        </Stack>
      )}
    </Box>
  );
}
